var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductEquivalenceCheck.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-cc2a33ea\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductEquivalenceCheck.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/equivalence-check/ProductEquivalenceCheck.vue
// module id = 609
// module chunks = 0